// extracted by mini-css-extract-plugin
export default {"scrollable-textarea":"style_scrollable-textarea__SyixR"};